import { FuseNavigationModelInterface } from '../core/components/navigation/navigation.model';
import { USER_TYPE } from '../core/services/users/profile.model';

export class FuseNavigationModel implements FuseNavigationModelInterface
{
    public model: any[];

    constructor()
    {
        this.model = [
            {
                'id'   : 'calendar',
                'title': 'Calendrier',
                'type' : 'item',
                'icon' : 'event',
                'url'  : '/calendar',
            },
            {
                'id'   : 'schedules',
                'title': 'Horaires',
                'type' : 'item',
                'icon' : 'schedule',
                'url'  : '/schedules',
            },
            {
                'id'   : 'chiffres',
                'title': 'Chiffres',
                'type' : 'item',
                'icon' : 'loyalty',
                'url'  : '/chiffres',
            },
            {
                'id'   : 'booking',
                'title': 'Réservation',
                'type' : 'item',
                'icon' : 'add_shopping_cart',
                'url'  : '/booking',
            },
            {
                'id'   : 'orders',
                'title': 'Particuliers',
                'type' : 'item',
                'icon' : 'directions_walk',
                'url'  : '/orders',
            },
            {
                'id'   : 'preorders',
                'title': 'Professionnels',
                'type' : 'item',
                'icon' : 'directions_bus',
                'url'  : '/preorders',
                'typesOnly' : [USER_TYPE.SUPERADMIN],
            },
            {
                'id'       : 'settings',
                'title'    : 'Paramètres',
                // 'translate': 'NAV.APPLICATIONS',
                'type'     : 'group',
                'icon'     : 'settings',
                'typesOnly' : [USER_TYPE.SUPERADMIN],
                'children' : [
                    {
                        'id'   : 'transactions',
                        'title': 'Caisse',
                        'type' : 'item',
                        'icon' : 'store_mall_directory',
                        'url'  : '/transactions',
                    },
                    {
                        'id'   : 'users',
                        'title': 'Comptes',
                        'type' : 'item',
                        'icon' : 'people',
                        'url'  : '/users',
                    },
                    {
                        'id'   : 'categories',
                        'title': 'Categories',
                        'type' : 'item',
                        'icon' : 'shopping_basket',
                        'url'  : '/categories',
                    },
                    {
                        'id'   : 'products',
                        'title': 'Produits',
                        'type' : 'item',
                        'icon' : 'directions_boat',
                        'url'  : '/products',
                    },
                    {
                        'id'   : 'vouchers',
                        'title': 'Bons réduction',
                        'type' : 'item',
                        'icon' : 'card_giftcards',
                        'url'  : '/vouchers',
                    },
                    {
                        'id'   : 'analytics',
                        'title': 'Stats',
                        'type' : 'item',
                        'icon' : 'pie_chart',
                        'url'  : '/analytics',
                    },
                ],
            },
            /* {
                'id'      : 'applications',
                'title'   : 'Applications',
                'translate': 'NAV.APPLICATIONS',
                'type'    : 'group',
                'children': [
                    {
                        'id'   : 'sample',
                        'title': 'Sample',
                        'translate': 'NAV.SAMPLE.TITLE',
                        'type' : 'item',
                        'icon' : 'email',
                        'url'  : '/sample',
                        'badge': {
                            'title': 25,
                            'translate': 'NAV.SAMPLE.BADGE',
                            'bg'   : '#F44336',
                            'fg'   : '#FFFFFF'
                        }
                    }
                ]
            } */
        ];
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/navigation/navigation.model.ts